"use strict";

exports.__esModule = true;
exports.default = void 0;
var _locale = require("../../lib/locale");
var _default = exports.default = {
  methods: {
    t() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _locale.t.apply(this, args);
    }
  }
};